var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import View from "@core/views";
import Toast from "@core/components/Toast";
var BinDetailView = /** @class */ (function (_super) {
    __extends(BinDetailView, _super);
    function BinDetailView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get Bin transactions and populate tab.
     */
    BinDetailView.prototype.getBinTransactions = function (binId) {
        var data = { object_id: binId, object_type: 'bin' };
        this.app.api.private('get_object_transactions', {
            data: data
        }).then(function (response) {
            var transactionTab = document.getElementById('transaction-tab');
            transactionTab.innerHTML = '';
            if (response.transactions.length == 0) {
                var html = '<div class="has-text-centered has-text-muted">No transactions</div>';
                transactionTab.innerHTML += html;
            }
            for (var i = 0; i < response.transactions.length; i++) {
                var html = "\n                    <article class=\"media tc-transaction tc-{{type}}\">\n                        <figure class=\"media-left\">\n                            <div class=\"tc-transaction-icon\">\n                               <i class=\"{{icon_class}}\"></i>\n                            </div>\n                        </figure>\n                        <div class=\"media-content\">\n                            <div class=\"content\">\n                                <strong>{{display_name}}</strong>\n                                &nbsp;<time class=\"is-pulled-right\" datetime=\"{{action_time}}\" >{{action_time_natural}}</time>\n                                <br />\n                                <section class=\"tc-transaction-details\">\n                                    {{details}}\n                                </section>\n                            </div>\n                        </div>\n                    </article>\n                ";
                html = html.replace('{{type}}', response.transactions[i].type)
                    .replace('{{icon_class}}', response.transactions[i].icon_class)
                    .replace('{{display_name}}', response.transactions[i].display_name)
                    .replace('{{action_time}}', response.transactions[i].action_time)
                    .replace('{{action_time_natural}}', response.transactions[i].action_time_natural)
                    .replace('{{details}}', response.transactions[i].details);
                transactionTab.innerHTML += html;
            }
        }, function (error) {
            if (error.serverError) {
                Toast.error(error.serverError.error);
            }
            else {
                Toast.error(django.gettext('Unable to load Bin transactions'));
            }
        });
    };
    /**
     * OnClick-listener for "Rush order"-button
     * @param buttonElement
     */
    BinDetailView.prototype.onRushOrderClick = function (buttonElement) {
        var binId = buttonElement.getAttribute('data-bin_pk');
        var data = { bin_id: binId };
        this.app.api.private('create_rush_order', {
            data: data
        }).then(function (response) {
            Toast.success(django.gettext('Rush order created successfully'));
        }, function (error) {
            if (error.serverError) {
                Toast.error(error.serverError.error);
            }
            else {
                Toast.error(django.gettext('Unable to create rush order, please try again'));
            }
        });
    };
    /**
     * OnClick-listener for "Order"-button
     * @param buttonElement
     */
    BinDetailView.prototype.onOrderClick = function (buttonElement) {
        var binId = buttonElement.getAttribute('data-bin_pk');
        var data = { bin_id: binId };
        this.app.api.private('create_order', {
            data: data
        }).then(function (response) {
            Toast.success(django.gettext('Order created successfully'));
        }, function (error) {
            if (error.serverError) {
                Toast.error(error.serverError.error);
            }
            else {
                Toast.error(django.gettext('Unable to create order, please try again'));
            }
        });
    };
    return BinDetailView;
}(View));
export default BinDetailView;
